import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";


const DetalhesProfessor = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [professor, setProfessor] = useState(null);

  useEffect(() => {
    carregarProfessor();
  }, [id]);

  const carregarProfessor = async () => {
    try {
      const response = await fetch(`/api/usuarios/${id}`);
      const data = await response.json();
      if (data.erro) {
        alert("Professor não encontrado.");
        navigate("/professores");
      } else {
        setProfessor(data);
      }
    } catch (error) {
      console.error("Erro ao carregar professor:", error);
      alert("Erro ao carregar os dados do professor.");
    }
  };

  const formatarDataParaExibicao = (dataISO) => {
    if (!dataISO) return "";
    const partes = dataISO.split("-");
    if (partes.length === 3) {
      return `${partes[2]}-${partes[1]}-${partes[0]}`; // dd-mm-aaaa
    }
    return dataISO;
  };

  const formatarTelefone = (telefone) => {
    if (!telefone) return "";
    const numeros = telefone.replace(/\D/g, ""); // Remove não numéricos
    if (numeros.length === 11) {
      return `(${numeros.slice(0, 2)}) ${numeros.slice(2, 7)}-${numeros.slice(7)}`;
    } else if (numeros.length === 10) {
      return `(${numeros.slice(0, 2)}) ${numeros.slice(2, 6)}-${numeros.slice(6)}`;
    }
    return telefone;
  };

  if (!professor) return <div>Carregando...</div>;

  return (
    <div className="form-wrapper form-coordenador">
      <h2 className="form-title">Detalhes do Professor</h2>

      <div className="form-row">
        <div className="form-group campo-cpf" style={{ width: "160px" }}>
          <label>CPF</label>
          <div className="campo-detalhe">{professor.cpf || "-"}</div>
          </div>
        <div className="form-group" style={{ flex: 1 }}>
          <label>Nome Completo</label>
          <div className="campo-detalhe">{professor.nome_completo || "-"}</div>
          </div>
      </div>

      <div className="form-row">
        <div className="form-group campo-genero" style={{ width: "210px" }}>
          <label>Gênero</label>
          <div className="campo-detalhe">{professor.genero || "-"}</div>
          </div>

        <div className="form-group campo-data" style={{ width: "160px" }}>
          <label>Data de Nascimento</label>
          <div className="campo-detalhe">{professor.data_nascimento ? formatarDataParaExibicao(professor.data_nascimento) : "-"}
        </div>
        </div>

        <div className="form-group" style={{ flex: 1 }}>
          <label>Cargo</label>
          <div className="campo-detalhe">{professor.cargo || "-"}</div>
          </div>
      </div>

      {/* 📢 Aqui começa a linha reestruturada conforme padrão do Coordenador */}
      <div className="form-row">
        <div className="form-group" style={{ width: "220px", flex: "none" }}>
          <label>Telefone</label>
          <div className="campo-detalhe">{formatarTelefone(professor.telefone) || "-"}</div>
        </div>

        <div className="form-group" style={{ width: "300px", flex: "none" }}>
          <label>Email</label>
          <div className="campo-detalhe">
            {professor.email ? (
              <a href={`mailto:${professor.email}`} target="_blank" rel="noopener noreferrer">
                {professor.email}
              </a>
            ) : (
              "-"
            )}
          </div>
        </div>

        <div className="form-group">
          <label>Usuário</label>
          <div className="campo-detalhe">{professor.usuario || "-"}</div>
        </div>
      </div>

      {/* 📢 Fim da linha reestruturada */}

      <div className="form-actions">
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => navigate("/professores")}
        >
          Voltar
        </button>

        <button
          type="button"
          className="btn btn-primary"
          onClick={() => navigate(`/professores/editar/${professor.id}`)}
        >
          Editar
        </button>

        <button
          type="button"
          className="btn btn-danger"
          onClick={async () => {
            if (window.confirm("Tem certeza que deseja excluir este professor?")) {
              try {
                const usuario_id = localStorage.getItem("user_id");
                await axios.delete(`/api/usuarios/${professor.id}?usuario_id=${usuario_id}`);
                alert("Professor excluído com sucesso.");
                navigate("/professores");
              } catch (error) {
                console.error("Erro ao excluir professor:", error);
                alert("Erro ao excluir professor.");
              }
            }
          }}
        >
          Excluir
        </button>
      </div>
    </div>
  );
};

export default DetalhesProfessor;

